<i *ngIf="vipInfo" [ngbTooltip]="'VIP:' + vipInfo" class="la la-crown"></i>
<i *ngIf="blackListInfo" [ngbTooltip]="'hx.client-indicator.nb.blacklist' | transloco: {blackListInfo: blackListInfo}" class="la la-ban"></i>
<i *ngIf="clientNote" [ngbTooltip]="'hx.client-indicator.nb.note' | transloco: {client: clientNote}" class="la la-comment"></i>
